import {createAction, props} from '@ngrx/store'
import {IMenu} from './menu.state'

export const setMenu = createAction('[MENU] Set MENU', props<{ menu: IMenu[] }>())
export const removeMenu = createAction('[MENU] Remove MENU')
